var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconTel2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.696 13.264a.34.34 0 0 1-.21.07h-.046a11.69 11.69 0 0 1-4.262-1.767 11.739 11.739 0 0 1-3.241-3.242A11.7 11.7 0 0 1 1.17 4.061a.312.312 0 0 1 .07-.256l2.068-2.069c.046-.046.112-.07.197-.07s.151.024.197.07l3.16 3.161c.046.047.07.112.07.198 0 .085-.024.15-.07.197L5.399 6.756a6.874 6.874 0 0 0 2.393 2.37l1.464-1.44a.232.232 0 0 1 .197-.093c.085 0 .151.031.198.093l3.113 3.091a.34.34 0 0 1 .07.21.34.34 0 0 1-.07.208l-2.068 2.069Z"
  })));
}
export default SvgCommonIconTel2;